<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p id="confirmation-title" class="modal-card-title">{{ title }}</p>
        <button @click="$emit('cancel')" class="delete" aria-label="close"></button>
      </header>

      <section v-if="!typedConfirmationRequired" class="modal-card-body">
        <span id="confirmation-message" v-html="message" />
      </section>
      <section v-if="typedConfirmationRequired" class="modal-card-body">
        <label class="label" v-html="message" />
        <input class="input" type="text" v-model="confirmValue" />
      </section>

      <footer class="modal-card-foot">
        <n-button-group>
          <n-button :disabled="buttonDisabled" variant="primary" @click="emit('confirm')">
            {{ confirmButtonLabel }}
          </n-button>
          <n-button v-if="showCancelButton" @click="emit('cancel')" variant="primary--outline">{{
            cancelButtonLabel
          }}</n-button>
        </n-button-group>
      </footer>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useSanitize } from '@/shared/composables/useSanitize';

const { sanitize } = useSanitize();

const props = defineProps({
  confirmButtonLabel: {
    type: String,
    default: 'Yes',
  },
  cancelButtonLabel: {
    type: String,
    default: 'Cancel',
  },
  showCancelButton: {
    type: Boolean,
    default: true,
  },
  confirmationTitle: {
    type: String,
  },
  confirmationMessage: {
    type: String,
  },
  typeConfirmationValidationMessage: {
    type: String,
  },
});

const confirmValue = ref('');

const title = computed(() => sanitize(props.confirmationTitle));
const message = computed(() => sanitize(props.confirmationMessage));
const buttonDisabled = computed(() => typedConfirmationRequired.value && !typedConfirmationValid.value);
const typedConfirmationRequired = computed(() => !!props.typeConfirmationValidationMessage);
const typedConfirmationValid = computed(() => props.typeConfirmationValidationMessage === confirmValue.value);

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();
</script>
